import React from "react";
import { getUscVehiclePowerOutput } from "../../../../../../../shared-logic/utils/uscSpecUtils";
import MeasureItem from "../common/MeasureItem";
import SpecItem from "../common/SpecItem";
import type { SpecsSectionPropsType } from "../Specifications";
import Text from "../../../../styles/atoms/Text";
import List from "../../../../styles/atoms/List";

const SectionEngine = ({ product, cultureName, title, specs, settings }: SpecsSectionPropsType): JSX.Element => {
    const vehiclePowerOutput = product
        ? getUscVehiclePowerOutput(product.engine, settings?.hideCombinedPowerOutput)
        : undefined;
    return (
        <div>
            <Text tag="h4" variant="h6">
                {title}
            </Text>
            <List variant="specs" tag="dl">
                {!!product.engine.cylinders && specs.cylinders && (
                    <SpecItem title={specs.cylinders.title} value={product.engine.cylinders} />
                )}

                {product.engine.displacement && product.engine.displacement.value > 0 && specs.displacement && (
                    <MeasureItem
                        title={specs.displacement.title}
                        measure={product.engine.displacement}
                        cultureName={cultureName}
                    />
                )}

                {vehiclePowerOutput && vehiclePowerOutput.value > 0 && specs.powerOutput && (
                    <MeasureItem
                        title={specs.powerOutput.title}
                        measure={vehiclePowerOutput}
                        cultureName={cultureName}
                    />
                )}

                {product.engine.fiscalPower && product.engine.fiscalPower.value > 0 && specs.fiscalPower && (
                    <MeasureItem
                        title={specs.fiscalPower.title}
                        measure={product.engine.fiscalPower}
                        cultureName={cultureName}
                    />
                )}

                {product.engine.batteryCapacity &&
                    product.engine.batteryCapacity.value > 0 &&
                    specs.batteryCapacity && (
                        <MeasureItem
                            title={specs.batteryCapacity.title}
                            measure={product.engine.batteryCapacity}
                            cultureName={cultureName}
                        />
                    )}
            </List>
        </div>
    );
};

export default SectionEngine;
